import {INITIAL_STATE} from "./directoryData";

export const directoryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return state
    }
}